import {useTheme, css} from "@emotion/react";
import {useState} from 'react';
import PropTypes from "prop-types";
import ImageGallery from 'react-image-gallery';
import { em } from "@util/convertUnits";
import CmsImageLoader from "../../../base/CmsImageLoader";

const SlideWidget = ({content}) => {

    const theme = useTheme();

    const {subtitle, slides} = content;
    const [slideIndex, setSlideIndex] = useState(0);
    const subheaderCss = css(`
        text-align:center;
        margin-top: 1em;
        min-width: 30em;
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            min-width: 40em;
            
        }

    `)
    
    const slidesCss = css(`
        text-align:center;
        text-align: left;
        margin-right:3em;
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            margin-left:12em;
            
        }
        
    `)
    
    const subheaderContainer = css(`
        width: 100%; 
        height: auto;
        object-fit: cover;
        position: relative;
        display: flex;
        align-items:center;
        flex-direction:column;
    `)

    const imageContainer = css(`
        display: flex;
        max-width: 30em;
        flex-direction: column;
        @media (min-width: ${em(theme.breakpoint.ns, 16)}) {
            width:70em;
            max-width: 100vw;
        }
    `);

    const formatted = slides.map(slide => {
        return {
            original: slide.image_url,
            originalTitle: slide.alt_text
        }
    })

    const renderImage = (item) => {
        return <CmsImageLoader className={'image-gallery-image'} url={item.original} alt={item.originalTitle} />
    }

    const config = {
        showThumbnails: false,
        items: formatted,
        renderItem: renderImage,
        onSlide: setSlideIndex,
        showFullscreenButton: false,
        showPlayButton: false,
        showBullets: true,
    }

    return <div css={subheaderContainer}>
            <h2 css={subheaderCss}>{subtitle}</h2>
            <div css={imageContainer}>
                <ImageGallery {...config} />
                    <h3 css={subheaderCss}>{slides[slideIndex].slide_label}</h3>
                </div>
                <p css={slidesCss}>{slides[slideIndex].slide_desc}</p>
    </div>;
};

SlideWidget.propTypes = {
    content: PropTypes.object,
};

export default SlideWidget;
